import { render, staticRenderFns } from "./InternalTransferTabTable.vue?vue&type=template&id=04de4a24"
import script from "./InternalTransferTabTable.vue?vue&type=script&lang=js"
export * from "./InternalTransferTabTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports